import { useCallback, useMemo } from 'react';
import { UnifiedAuthView } from './UnifiedAccountView';
import { createAuthConfigFetchers } from './helpers/createAuthConfigFetcher';
import { deleteAccount } from './api/UnifiedAccountApi';
import { jsx as _jsx } from "react/jsx-runtime";
export function UnifiedAccountModal({
  inline = false,
  portalId,
  appId,
  appName,
  oAuthScope,
  oAuthScopes,
  accountId,
  mcpParams,
  oAuthorMigrationParams,
  onComplete,
  onCancel,
  config
}) {
  const {
    shouldDeleteOnFailure,
    introScreen,
    successScreen
  } = config !== null && config !== void 0 ? config : {};
  const fetchers = useMemo(() => createAuthConfigFetchers({
    portalId,
    appId,
    appName,
    oAuthScope,
    oAuthScopes,
    mcpParams: mcpParams !== null && mcpParams !== void 0 ? mcpParams : undefined
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // oAuthScopes is serialised to avoid array reference instability
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [portalId, appId, appName, oAuthScope, oAuthScopes === null || oAuthScopes === void 0 ? void 0 : oAuthScopes.join('\0'), mcpParams]);
  const handleComplete = useCallback(({
    accountId: newAccountId
  }) => {
    try {
      onComplete(newAccountId);
    } catch (error) {
      console.error('Failed to complete account creation:', error);
      const shouldCleanup = shouldDeleteOnFailure ? shouldDeleteOnFailure(newAccountId) : true;
      if (shouldCleanup) {
        void deleteAccount(newAccountId);
      }
      throw error;
    }
  }, [onComplete, shouldDeleteOnFailure]);
  const isMigrationReconnect = !!oAuthorMigrationParams;
  const isReauth = !isMigrationReconnect && !!accountId;
  const fetchAuthConfig = isMigrationReconnect ? () => fetchers.forMigrationReconnect(oAuthorMigrationParams === null || oAuthorMigrationParams === void 0 ? void 0 : oAuthorMigrationParams.oAuthorAccountId) : isReauth ? () => fetchers.forReconnect(accountId) : fetchers.forNewAccount;
  return /*#__PURE__*/_jsx(UnifiedAuthView, {
    isModal: !inline,
    isReauth: isMigrationReconnect || isReauth,
    portalId: portalId,
    onComplete: handleComplete,
    onCancel: onCancel,
    introScreen: introScreen,
    successScreen: successScreen,
    fetchAuthConfig: fetchAuthConfig
  });
}
export default UnifiedAccountModal;